import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMegaphoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={18}
    fill="none"
    viewBox="0 0 16 18"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M9.423 10.61V4.147m0 6.463 4.746 2.817c.311.185.698-.048.698-.42V1.75c0-.372-.387-.605-.698-.42L9.423 4.146m0 6.463H3.978C2.26 10.61.868 9.163.868 7.38c0-1.785 1.392-3.232 3.11-3.232h5.445"
    />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="m4.566 14.891-.588-4.282h3.11l.527 3.83c.133.963-.587 1.826-1.524 1.826-.766 0-1.416-.586-1.525-1.374Z"
    />
  </svg>
);
export default SvgMegaphoneIcon;
